<script lang="ts">
import type { HTMLInputAttributes } from 'svelte/elements'

import { isDesktop, isTouchDevice } from '@/modules/device'
import { INPUT_MAXLENGTH } from '@/modules/form'

type Props = Omit<HTMLInputAttributes, 'value'> & {
	isInvalid?: boolean
	testId?: string
	value: string
	onChange?: (event: Event) => void
	onBlur?: (event: Event) => void
	onInput?: (event: Event) => void
}

let { value = $bindable<string>(''), isInvalid = false, testId, onChange, onBlur, onInput, ...rest }: Props = $props()
</script>

<input
	aria-invalid={isInvalid || undefined}
	bind:value
	class={[
		'block w-full px-3 py-2 text-base-input leading-5.5 border border-slate-200 text-slate-800 rounded-xl focus:border-blue-500 focus:ring-blue-500 placeholder:text-slate-300 transition-colors',
		isInvalid && 'invalid',
		$isDesktop && 'text-sm',
	]}
	maxlength={INPUT_MAXLENGTH}
	autocomplete={isTouchDevice() ? 'off' : undefined}
	onchange={onChange}
	onblur={onBlur}
	oninput={onInput}
	data-testid={testId}
	{...rest}
/>

<style lang="postcss">
.invalid {
	@apply border-red-500;
}
</style>
